module.exports = __webpack_public_path__ + "media/images/lb/600-4115fa2754607495051b1242b2478216.svg";